import gsap from 'gsap';

class Navigation {
    /**
     * Constructor
     */
    constructor() {
        this.DOM = {
            el: document.querySelector('.kg-navigation')
        };

        // Init
        this.init();

        return this;
    }

    // ======================================================================
    // Init
    // ======================================================================
    init() {}
}

export default Navigation;
